import React, { createContext, useContext, useEffect, useRef } from "react";

const KeyEventManagerContext = createContext(null);

export const useKeyEventManager = () => useContext(KeyEventManagerContext);

export const KeyEventManagerProvider = ({ children }) => {
    const handlers = useRef([]);

    const registerKeyHandler = (handler, priority = 0) => {
        const entry = { handler, priority };
        handlers.current.push(entry);
        handlers.current.sort((a, b) => b.priority - a.priority); // High first

        return () => {
            handlers.current = handlers.current.filter(h => h !== entry);
        };
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            for (const { handler } of handlers.current) {
                const handled = handler(event);
                if (handled === true) {
                    event.stopPropagation();
                    break;
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <KeyEventManagerContext.Provider value={{ registerKeyHandler }}>
            {children}
        </KeyEventManagerContext.Provider>
    );
};
